import React from 'react';
import Layout from '../components/Layout';
import './DashboardPage.css'; // 添加样式文件

function DashboardPage() {
    return (
        <Layout>
            <div className="dashboard-container">
                <h1>Dashboard</h1>
                <p>Welcome to the dashboard!</p>
                <p>开发中。。。。。</p>
            </div>
        </Layout>
    );
}

export default DashboardPage;